import { lazyWithPreload as lazy } from 'react-lazy-with-preload';

export const DirectDebit = {
  Content: lazy(
    () =>
      import(
        'components/direct-sales/direct-debit-revamp/components/DirectDebitContent'
      )
  ),
  RightSidebar: lazy(
    () =>
      import(
        'components/direct-sales/direct-debit-revamp/components/DirectDebitSidebarRight'
      )
  ),
  Header: lazy(
    () =>
      import(
        'components/direct-sales/direct-debit-revamp/components/DirectDebitHeader'
      )
  ),
  Footer: lazy(
    () =>
      import(
        'components/direct-sales/direct-debit-revamp/components/DirectDebitFooter'
      )
  )
};

export default DirectDebit;
